export function extractCountry(country: $TSFixMe) {
  return {
    code: country.code,
    name: country.name,
  };
}

export function extractCountries(rawCountries: $TSFixMe) {
  return rawCountries.countries.map((country: $TSFixMe) =>
    extractCountry(country),
  );
}

export function extractCountriesWithUserCountry(rawCountries: $TSFixMe) {
  return {
    countries: extractCountries(rawCountries),
    userCountryCode: rawCountries.user_country_code,
  };
}
